import { useMemo } from "react";
import { useRuntimeConfig } from "./useRuntimeConfig";

export const useVerificationMethods = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");

    const verificationMethods = useMemo(
        () => COMMON_SITE_CONFIGS.verification.config.filter((method) => method.enable),
        [COMMON_SITE_CONFIGS.verification.config],
    );

    return {
        verificationMethods,
    };
};
